import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import { Avatar, EmptyState, Loader, Page, PageHead } from '../components/UI';
import { useApp } from '../context/AppContext';
import { api } from '../utils/api';
import { timeAgo } from '../utils/format';

const ICONS = { interest: ['heart', 'rose'], accept: ['check', 'teal'], decline: ['x', 'muted'], view: ['eye', 'violet'], shortlist: ['star', 'gold'], message: ['chat', 'teal'], system: ['sparkle', 'violet'], premium: ['crown', 'gold'] };
const LINK = { interest: () => '/interests', accept: (n) => `/messages/${n.actor?.profileId}`, premium: () => '/premium' };

export default function Notifications() {
  const { refreshCounts } = useApp();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api('/notifications')
      .then((d) => {
        setItems(d.items);
        if (d.unread) api('/notifications/read-all', { method: 'PUT' }).then(refreshCounts);
      })
      .catch(() => setItems([]));
  }, [refreshCounts]);

  return (
    <Page>
      <div className="container narrow">
        <PageHead eyebrow="Activity" title="Notifications" sub="Everything happening around your profile." />
        {!items ? <Loader label="" /> : !items.length ? (
          <EmptyState icon="bell" title="All quiet for now" text="Interests, visits and messages will show up here." />
        ) : (
          <motion.div className="notes" initial="hidden" animate="show" variants={{ hidden: {}, show: { transition: { staggerChildren: 0.04 } } }}>
            {items.map((n) => {
              const [icon, tint] = ICONS[n.type] || ICONS.system;
              const to = (LINK[n.type] || (() => (n.actor ? `/profile/${n.actor.profileId}` : null)))(n);
              const body = (
                <>
                  <span className="note-item__avatar">
                    {n.actor ? <Avatar src={n.actor.photo} name={n.actor.name} size={46} locked={n.actor.photoLocked} /> : <span className={`note-item__sys tint-${tint}`}><Icon name={icon} size={20} /></span>}
                    {n.actor && <span className={`note-item__type tint-${tint}`}><Icon name={icon} size={11} stroke={2.6} /></span>}
                  </span>
                  <span className="note-item__text">
                    <span>{n.actor && <strong>{n.actor.name} </strong>}{n.text}</span>
                    <small className="muted">{timeAgo(n.createdAt)}</small>
                  </span>
                  {!n.read && <span className="note-item__dot" />}
                </>
              );
              return (
                <motion.div key={n.id} variants={{ hidden: { opacity: 0, y: 12 }, show: { opacity: 1, y: 0 } }}>
                  {to ? <Link to={to} className={`note-item ${n.read ? '' : 'is-unread'}`}>{body}</Link> : <div className={`note-item ${n.read ? '' : 'is-unread'}`}>{body}</div>}
                </motion.div>
              );
            })}
          </motion.div>
        )}
      </div>
    </Page>
  );
}
